export const TECH_CHECK_PATH = "/tech-check/video";
export const TEAM_PATH = "/member-management";
export const GET_STARTED_PATH = "/get-started";
